let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
let DbRecorder = require("./DbRecorder.js");
let BillModel = require("../model/BillModel.js");
let TableModel = require("../model/TableModel.js");
import i18n from "../utils/i18n";
let PrinterModalUtil = require("../utils/PrinterModalUtil.js");
import BillMerger from "./BillMerger.js";
import PrintService from "../service/PrintService.js";
import TooieStatusService from "../service/TooieStatusService.js";
import PurchaseLicenseService  from "../service/PurchaseLicenseService.js";
import BillPayService from "../service/BillPayService.js";
import NotificationService from"../service/NotificationService.js";

import POS from "../POS.js";

let main = function () {
    return (function () {
        //这个地方需要改进，因为this关键字，在这里事实上是window
        var BillRecorder = {}, retrieveNewBillsInterval = 60 * 1000, status = POS.getStatus(),
            syncStatus = POS.getSyncStatus(), self = BillRecorder,
            pm = new PrinterModalUtil;

        /**
         * 从POS Table Collection中取到所有的Bill
         * @returns {*}
         */
        BillRecorder.getAllBills = function () {
            return _.filter(DbRecorder.search(POS.get("tableCollection")), function (model) {
                return model instanceof BillModel;
            });
        };

        /**
         * 取所有不是第三方支付但是还没付款的外卖bills
         */
        BillRecorder.getTakeOutBills = function () {
            var unPaidArray = {};
            unPaidArray.takeOutBills = [];
            _.filter(DbRecorder.search(POS.get("tableCollection").findWhere({multiple: true})), function (model) {
                if (model instanceof BillModel) {
                    if (model.get('id') && model.get('payStatus') != 'Paid' && model.get('status') != 'ThirdParty') {
                        unPaidArray.takeOutBills.push(model.get('id'));
                    }
                }
            });
            return unPaidArray;
        };

        /**
         * 取所有第三方支付但是没有打印的Bill
         */
        BillRecorder.getPrintedBills = function () {
            var printedArray = {};
            printedArray.printedList = [];
            _.filter(POS.get("tableCollection").where({multiple: true}), function (table) {
                if (table instanceof TableModel) {
                    _.filter(table.getBillCollection().where({
                        status: "ThirdParty",
                        printed: false
                    }), function (bill) {
                        printedArray.printedList.push(bill.get('id'));
                    });
                }
            });
            return printedArray;
        };

        /**
         * 打印所有第三方已支付的bills
         */
        BillRecorder.printBills = function () {
            _.filter(POS.get("tableCollection").where({multiple: true}), function (table) {
                if (table instanceof TableModel) {
                    _.filter(table.getBillCollection().where({
                        status: "ThirdParty",
                        printed: false
                    }), function (bill) {
                        bill.table = table.toJSON();
                        pm._print(bill, POS);
                    });
                }
            });
        };

        /**
         * 监听Bill
         */
        BillRecorder.monitorTables = function () {
            var tables = POS.get("tableCollection");
            //如果餐台收到账单提交申请，那么就向后台保存账单
            tables.forEach(function (table) {
                // 当餐桌shouldSubmitTime改变时，把bill存到后台
                table.on("change:shouldSubmitTime", function () {
                    self.reschedulePollSyncNow();
                });
                //如果餐台收到付款请求，那么就向后台支付当前账单
                table.on("change:paidTime", function () {
                    self.reschedulePollSyncNow();
                });
                //当桌子的currentBill发生change时，记录新的currentBill
                table.on("change:currentBill", function () {
                    var bill = table.getCurrentBill();
                    if (bill) {
                        self.recordMove(bill);
                        self.recordConfirm(bill);
                        self.recordRefund(table, bill);
                        self.recordComplete(bill);
                        self.recordCancel(bill);
                        //self.switchBill(table, bill);
                    }
                });
                //记录当前桌子所有未完成账单，作用于桌子初始化后
                table.getBillCollection().forEach(function (bill) {
                    self.recordMove(bill);
                    self.recordConfirm(bill);
                    self.recordRefund(table, bill);
                    self.recordComplete(bill);
                    self.recordCancel(bill);
                });
                //当有订单添加到桌子时，记录订单状态改变，网络订单的桌子会发生这种情况
                table.getBillCollection().on("add", function (bill) {
                    self.recordMove(bill);
                    self.recordConfirm(bill);
                    self.recordRefund(table, bill);
                    self.recordComplete(bill);
                    self.recordCancel(bill);
                });
                //记录当前currentBill
                var bill = table.getCurrentBill();
                self.recordMove(bill);
                self.recordConfirm(bill);
                self.recordRefund(table, bill);
                self.recordComplete(bill);
                self.recordCancel(bill);
            });
        };

        /**
         * 记录bill变更
         * @param bill
         */
        BillRecorder.recordConfirm = function (bill) {
            //如果bill没有被记录变更，则进行记录，否则跳过
            if (!bill.__recordConfirmTime) {
                bill.__recordConfirmTime = true;
                bill.on("change:shouldConfirmTime", function () {
                    self.reschedulePollSyncNow();
                });
            }
        };

        /**
         * 记录bill变更
         * @param bill
         */
        BillRecorder.recordMove = function (bill) {
            //如果bill没有被记录变更，则进行记录，否则跳过
            if (!bill.__recordMove) {
                bill.__recordMove = true;
                bill.on("change:shouldMoveTime", function () {
                    self.reschedulePollSyncNow();
                });
            }
        };

        /**
         * 记录餐桌退单，如果退单未保存，则先执行保存操作
         * @param table
         * @param bill
         */
        BillRecorder.recordRefund = function (table, bill) {
            if (!bill.__recordRefundTime) {
                bill.__recordRefundTime = true;
                bill.on("change:refundTime", function () {
                    self.reschedulePollSyncNow();
                });
            }
        };

        /**
         * 记录完成订单
         * @param bill
         */
        BillRecorder.recordComplete = function (bill) {
            if (!bill.__recordCompleteTime) {
                bill.__recordCompleteTime = true;
                bill.on("change:shouldCompleteTime", function () {
                    self.reschedulePollSyncNow();
                });
            }
        };

        /**
         * 记录取消订单
         * @param bill
         */
        BillRecorder.recordCancel = function (bill) {
            if (!bill.__recordCancel) {
                bill.__recordCancel = true;
                bill.on("change:shouldCancelTime", function () {
                    self.reschedulePollSyncNow();
                });
            }
        };

        /**
         * 请求后台cancel此bill
         */
        BillRecorder.cancelBill = function (bill) {
            var restaurant = POS.getRestaurant();
            var jxhr;
            //如果订单没有ID，或者订单没有准备好取消，或者订单正在处理
            //那么返回成功状态的deferred对象
            if (!bill.id || !bill.isPrepareForCancel() || bill.getProcessing()) {
                jxhr = $.Deferred();
                return jxhr.resolve();
            }
            //设定订单为处理中
            bill.setProcessing();

            console.log("BillRecorder.cancelBill() cancelling bill: " + bill.id);
            jxhr = $.post("/bill/cancel", {restaurantId: restaurant.id, id: bill.id});

            //完成后标记订单为取消
            jxhr.done(function (response) {
                bill.markCancel();
            });
            jxhr.fail(function (response) {
                console.log("Cancel bill failed");
            });

            //最后取消订单执行状态
            jxhr.always(function (response) {
                bill.unsetProcessing();
            });

            return jxhr;
        };

        /**
         * 请求后台move此bill
         */
        BillRecorder.moveBill = function (bill) {
            var url, jxhr;
            if (!bill.id || !bill.isPrepareForMove() || bill.getProcessing()) {
                jxhr = $.Deferred();
                jxhr.resolve();
                return jxhr;
            }
            bill.setProcessing();
            url = "/bill/move";
            var data = {
                restaurantId: POS.get("restaurantModel").id,
                billId: bill.id,
                tableId: bill.get('shouldMoveToTableId')
            };
            jxhr = $.post(url, data);
            console.log("BillRecorder.moveBill() moving bill " + bill.id + " to table " + bill.get('shouldMoveToTableId'));
            jxhr.done(function (response) {
                if (!response.success) {
                    console.log("move bill failed with a non-json response", bill);
                    return;
                }
                bill.markMove();
                bill.set({version: response.version});
            });
            jxhr.fail(function (response) {
                console.log("Move bill failed", bill);
            });
            jxhr.always(function (response) {
                bill.unsetProcessing();
            });
            return jxhr;
        };

        /**
         * 请求后台save此bill
         */
        BillRecorder.saveBill = function (table, bill) {
            var url, jxhr, items = bill.getUnSavedItems(), data, item, json, mJSON;
            if ((bill.id && bill.isPaid()) || items.length < 1 || bill.getProcessing()) {
                jxhr = $.Deferred();
                jxhr.resolve();
                return jxhr;
            }
            bill.setProcessing();
            url = bill.id ? "/bill/addItems" : "/bill/save";
            data = {
                id: bill.id,
                restaurantId: POS.get("restaurantModel").id,
                tid: table.id,
                note: bill.get("note"),
                jsonOrders: JSON.stringify(_.map(items, function (item) {
                    return item.toJSON()
                })),
                uuid: bill.get('uuid'),
                checkInDate: bill.get('checkInTime'),
                orderDate: bill.get("orderDate"),
                version: bill.get('version'),
                serial: bill.get('serial'),
                dinerCount: bill.get('dinerCount'),
                bookingId: bill.get('booking') ? bill.get('booking').id : null
            };
            jxhr = $.post(url, data);
            if (bill.id) {
                console.log("BillRecorder.saveBill() adding items to bill: " + bill.id);
            } else {
                console.log("BillRecorder.saveBill() saving new bill: " + bill.id);
            }
            jxhr.done(function (response) {
                if (!response.success) {
                    console.log("Save bill failed with a non-json response", bill);
                    return;
                }
                json = response.bill;
                bill.set({id: json.id, sid: json.sid, status: json.status, version: json.version});
                _.each(items, function (model) {
                    mJSON = model.toJSON();
                    item = _.find((response.items || json.items), function (item) {
                        return (mJSON.menuItem.id == item.menuItem.id) &&
                            (mJSON.priority == item.priority) &&
                            (mJSON.quantity == item.quantity)
                    });
                    if (item) {
                        model.set({id: item.id});
                    }
                });
            });
            jxhr.fail(function (response) {
                console.log("Save bill failed", bill);
            });
            jxhr.always(function (response) {
                bill.unsetProcessing();
            });
            return jxhr;
        };

        /**
         * 请求后台confirm此bill
         */
        BillRecorder.confirmBill = function (bill) {
            var jxhr, restaurant = POS.getRestaurant();
            if (!bill.id || !bill.isPrepareForConfirm() || bill.getProcessing()) {
                jxhr = $.Deferred();
                jxhr.resolve();
                return jxhr;
            }
            bill.setProcessing();
            console.log("BillRecorder.confirmBill() confirming bill: " + bill.id);
            jxhr = $.post("/bill/confirmBill", {billId: bill.id, restaurantId: restaurant.id});
            jxhr.done(function (response) {
                bill.markConfirm(response.status);
                bill.set({version: response.version});
            });
            jxhr.fail(function (response) {
                console.log("Confirm bill " + bill.id + " failed");
            });
            jxhr.always(function (response) {
                bill.unsetProcessing();
            });
            return jxhr;
        };

        /**
         * 请求后台pay此bill
         */
        BillRecorder.payBill = function (bill) {
            var jxhr, data, restaurant = POS.get("restaurantModel"), discountStatus, discountItem,
                items = bill.getBillItems().models,
                payments = _.filter(bill.get("payments").models, function (payment) {
                    return !payment.id
                }),
                membership = bill.get("membership"),
                discount = bill.get("discount");

            if (payments.length < 1 || !bill.id || bill.getProcessing()) {
                jxhr = $.Deferred();
                jxhr.resolve();
                return jxhr;
            }
            if (items.length < 1 || bill.getProcessing()) {
                jxhr = $.Deferred();
                jxhr.resolve();
                return jxhr;
            }
            bill.setProcessing();
            discountStatus = bill.checkSingeDiscount();
            if (discountStatus) {
                discountItem = JSON.stringify(_.map(items, function (item) {
                    return item.toJSON()
                }))
            }
            data = {
                billId: bill.id,
                note: bill.get("note"),
                noFee: bill.get('noFee'),
                waiter: bill.get('waiter') ? JSON.stringify(bill.get('waiter')) : null,
                restaurantId: restaurant.id,
                pays: JSON.stringify(_.map(payments, function (payment) {
                    return payment.toJSON()
                })),
                membershipId: membership ? membership.id : 0,
                discountId: discount ? discount.id : 0,
                discountItem: discountItem,
                dinerCount: bill.get("dinerCount"),
                taxId: bill.get('taxId'),
                payDate: bill.get("payDate"),
                bookingId: bill.get('booking') ? bill.get('booking').id : null
            };
            console.log("BillRecorder.payBill() paying bill: " + bill.id);
            jxhr = $.post("/pos/pay", data);
            jxhr.done(function (response) {
                bill.get("payments").reset();
                bill.set({version: response.bill.version});
                _.each(response.bill.payments, function (payment) {
                    bill.get("payments").add(payment);
                });
            });
            jxhr.fail(function (response, xhr) {
                if (xhr.status == 409) {
                    bill.get("payments").reset();
                    bill.set({version: response.bill.version});
                    _.each(response.bill.payments, function (payment) {
                        bill.get("payments").add(payment);
                    });
                } else {
                    console.log("Pay bill " + bill.id + " failed");
                }
            });
            jxhr.always(function (response) {
                bill.unsetProcessing();
            });
            return jxhr;
        };

        /**
         * 请求后台refund此bill
         */
        BillRecorder.refundBill = function (bill) {
            var jxhr, data, items = [], restaurant = POS.get("restaurantModel");
            bill.getBillItems().forEach(function (item) {
                if (item.get("shouldRefund")) {
                    items.push({
                        id: item.id,
                        quantity: item.get("shouldRefundQuantity"),
                        reason: item.get("refundNote"),
                        paid: item.get("paid")
                    });
                }
            });
            // only deal with refund of bill items when bill is paid, because the payBill command has already dealt with
            // cancellation of items
            if (items.length < 1 || !bill.id || bill.getProcessing()) {
                jxhr = $.Deferred();
                jxhr.resolve();
                return jxhr;
            }
            bill.setProcessing();
            //离线后同步，将bill的折扣信息传到后台，用于后台计算带有折扣的订单的退款金额
            data = {
                id: bill.id,
                restaurantId: restaurant.id,
                reason: bill.get("refundReason"),
                discountId: bill.get("discount") ? bill.get("discount").id : 0,
                jsonItems: JSON.stringify(items),
                refundStatus: bill.get("refundStatus")
            };
            console.log("BillRecorder.refundBill() refunding bill: " + bill.id);
            jxhr = $.post("/bill/refunds", data);
            jxhr.done(function (response) {
                if (!response.success) {
                    console.log(response);
                    return;
                }
                _.each(response.items, function (refundItem) {
                    var item = bill.getBillItems().find({id: refundItem.billItemId});
                    if (refundItem.payment) {
                        bill.get("payments").add(refundItem.payment);
                    }
                    if (item && item.get('shouldRefund')) {
                        item.unset("shouldRefund");
                        item.set({hasRefund: true});
                    }
                });
                if (response.offRefund) {
                    bill.get("payments").add(response.offRefund);
                }
                if (response.bill) {
                    bill.set({version: response.bill.version});
                }
            });
            jxhr.fail(function (response) {
                console.log("Refund bill " + bill.id + " failed");
            });
            jxhr.always(function (response) {
                bill.unsetProcessing();
            });
            return jxhr;
        };

        /**
         * 请求后台complete此bill
         */
        BillRecorder.completeBill = function (bill) {
            var jxhr, restaurant = POS.get("restaurantModel");
            if (!bill.id || !bill.isPrepareForComplete() || bill.getProcessing()) {
                jxhr = $.Deferred();
                jxhr.resolve();
                return jxhr;
            }
            bill.setProcessing();
            console.log(new Date() + " BillRecorder.completeBill() completing bill: " + bill.id);
            jxhr = $.post("/bill/completeBill", {billId: bill.id, restaurantId: restaurant.id});
            jxhr.done(function (response) {
                bill.markComplete();
                if (response.bill) {
                    bill.set({version: response.bill.version});
                }
                // why refresh?
                // POS.needRefresh = true;
            });
            jxhr.fail(function (response) {
                console.log("Complete bill " + bill.id + " failed");
                console.log(i18n.msg("pos.bill.completed.fail"));
                if (response.status === 409) {
                    bill.markComplete();
                }
            });
            jxhr.always(function (response) {
                bill.unsetProcessing();
            });
            return jxhr;
        };

        /**
         * 为订单切换桌子，因为这个不是一个关键的处理，所以没有做记录
         * @param table
         * @param bill
         */
        var switchBill = function (table, bill) {
            /** var restaurant = POS.getRestaurant();
             var jxhr = $.post("/pos/switchTableCurrentBill", {
                    restaurantId: restaurant.id,
                    tableId: table.id,
                    billId: bill.id
                });
             console.log("BillRecorder.switchBill() switching current bill of table " + table.id + " to " + bill.id);
             jxhr.done(function (response) {
                    console.log("table " + table.get('name') + '(' + table.id + ') has switched current bill to ' + bill.id);
                });
             jxhr.fail(function (response) {
                    console.log("table " + table.get('name') + '(' + table.id + ') failed to switch current bill to ' + bill.id);
                }); */
            // console.log("XXXXXX NOT TO SWITCH TABLE ANYMORE");
        };

        /**
         * 一个执行deferred对象List的方法
         * 所有的deferred对象执行完毕后，标识listener为已完成
         * 当然这里也可以返回一个deferred object
         * @param listener
         * @param deferreds
         */
        BillRecorder.deferredCycle = function (listener, deferreds) {
            if (deferreds.length > 0) {
                var deferred = deferreds.shift();
                deferred.func.apply(BillRecorder, deferred.arguments).always(function () {
                    self.deferredCycle(listener, deferreds);
                });
            } else {
                listener.set({finished: true});
            }

        };

        /**
         * 在这里处理了一个订单的保存，确认，退单支付以及取消和完成等逻辑
         * @param table
         * @param bill
         * @returns {*}
         */
        BillRecorder.processBill = function (table, bill) {
            var deferred = $.Deferred();
            var listener = new Backbone.Model({});
            listener.on("change:finished", function () {
                deferred.resolve();
            });
            var deferredList = [];
            //这里的执行顺序不可改变！
            //The process order is confirmed, and do not change it!
            deferredList.push({func: self.saveBill, arguments: [table, bill]});
            deferredList.push({func: self.moveBill, arguments: [bill]});
            deferredList.push({func: self.confirmBill, arguments: [bill]});
            //不知为何有2次confirm的过程,先comment掉
            //deferredList.push({func: self.confirmBill, arguments: [bill]});

            //退单发生在支付前面的意思是如果订单项目已付款，则生成一个负的退单，
            //如果订单未付款，则不用生成支付
            deferredList.push({func: self.refundBill, arguments: [bill]});

            //pay时，则可以根据退单状况，准确的进行付款
            //如果先付，再退，那么如果里面已经发生了退单，那么付的钱会少于要付的钱，而这部分事实上已经退了
            //然后因为后台不知道，就会发生支付金额不足的错误！
            deferredList.push({func: self.payBill, arguments: [bill]});

            //取消订单，无论账单发生了什么，都是可以取消的
            deferredList.push({func: self.cancelBill, arguments: [bill]});
            //只有支付状态为已支付（后台实时计算的值）的订单才可以被支付
            deferredList.push({func: self.completeBill, arguments: [bill]});
            self.deferredCycle(listener, deferredList);
            return deferred;
        };

        /**
         * 在这里处理了一个桌子上所有订单的操作
         * @param listener
         * @param table
         * @param bills
         */
        BillRecorder.processBills = function (listener, table, bills) {
            if (bills.length > 0) {
                var bill = bills.shift(), deferred = self.processBill(table, bill);
                deferred.always(function () {
                    listener.set({billCount: listener.get('billCount') + 1});
                    self.processBills(listener, table, bills);
                });
            } else {
                listener.set({finished: true});
            }
        };

        /**
         * 这里处理了所有桌子上订单的操作
         * @param listener
         * @param tables
         */
        BillRecorder.processTableAndBills = function (listener, tables) {
            if (tables.length > 0) {
                var to = tables.shift(), subListener = new Backbone.Model({billCount: 0}), table = to.table, bills = to.bills;
                subListener.on("change:finished", function () {
                    listener.set({billCount: subListener.get('billCount') + listener.get('billCount')});
                    self.processTableAndBills(listener, tables);
                });
                self.processBills(subListener, table, bills);
            } else {
                listener.set({finished: true});
            }
        };


        /**
         * Submit all unfinished bills to the server. Return a Deferred so further actions can be chained.
         */
        BillRecorder.postUnfinishedBills = function () {
            console.log(new Date() + " processing unfinished bills");
            var deferred = $.Deferred();
            status.set({processingUnfinishedBills: true});
            var listener = new Backbone.Model({billCount: 0});
            listener.on("change:finished", function () {
                try {
                    if (!POS.syncInitialised) {
                        status.set({processingUnfinishedBills: false});
                        POS.syncInitialised = true;
                        if (POS.needRefresh) {
                            $('#bigLoading').removeClass('hidden');
                            _.delay(function () {
                                window.location.reload();
                            }, 3000);
                            return;
                        }
                    }
                } finally {
                    console.log(new Date() + " " + listener.get('billCount') + " local bills processed");
                    deferred.resolve();
                }
            });

            var tableAndBills = [];
            POS.get("tableCollection").forEach(function (table) {
                var bills = _.filter(DbRecorder.search(table), function (model) {
                    return model instanceof BillModel;
                });
                tableAndBills.push({table: table, bills: bills});
            });
            self.processTableAndBills(listener, tableAndBills);
            return deferred;
        };


        /**
         * Part of the sync routing to fetch bills from the server and sync with local bills.
         * It returns a Deferred object so it can be chained.
         */
        BillRecorder.fetchAndSyncBills = function () {
            console.log(new Date() + " starts syncing bills");
            var restaurant = POS.getRestaurant();
            var jxhr;
            var deferred = $.Deferred();

            jxhr = $.post("/bill/latest", {id: restaurant.id,lastReadTime:localStorage.getItem('lastReadTime') || 0});
            jxhr.done(function (response) {
                try {
                    DbRecorder.setOnline();
                    PrintService.getPrinterStatus().set({offline: false});
                    if (typeof(response) == 'string') {
                        alert(i18n.msg("pos.session.lost"));
                        // window.location.reload();
                        return;
                    }
                    if (!response.success) {
                        return;
                    }
                    localStorage.setItem("lastReadTime", new Date().getTime());
                    _.each(response.bills, function (bill) {
                        // console.log("processing server bill " + bill.id);
                        var table = POS.getTables().get(bill.table.id);
                        if (table) {
                            var bills = table.getBillCollection();
                            var currentBill = table.getCurrentBill();
                            var localBill = currentBill && currentBill.id == bill.id ? currentBill : bills.get(bill.id);
                            if (localBill) {
                                // bill found locally on this table.
                                // local and server both have the same bill
                                if (bill.version == localBill.get('version')) {
                                    // same version - do nothing.
                                } else {
                                    console.log(new Date() + " SYNC: local bill " + bill.id + " exist and version differs (" + localBill.get('version') + " vs " + bill.version + ")- merge with local db");
                                    BillMerger.merge(localBill, new BillModel(bill));
                                }
                                if (currentBill && currentBill.id == localBill.id && (localBill.isCompleted() || localBill.isPaid())) {
                                    table.createNewBill();
                                    table.trigger('change');
                                    console.log("triggering table change!!!");
                                }
                            } else {
                                // bill not found on this table.
                                var billExistsOnOtherTable = POS.getTableOfBill(bill.id);
                                if (billExistsOnOtherTable) {
                                    console.log(new Date() + " SYNC: local bill " + bill.id + " has been moved to another table: " + billExistsOnOtherTable.id + " -> " + bill.table.id);
                                    localBill = billExistsOnOtherTable.getBillCollection().get(bill.id);
                                    if (!localBill && billExistsOnOtherTable.getCurrentBill().id == bill.id) {
                                        localBill = billExistsOnOtherTable.getCurrentBill();
                                    }
                                    if (localBill) {
                                        BillMerger.merge(localBill, new BillModel(bill));
                                        if (billExistsOnOtherTable.getCurrentBill() && billExistsOnOtherTable.getCurrentBill().id == localBill.id && (localBill.isCompleted() || localBill.isPaid())) {
                                            table.createNewBill();
                                            table.trigger('change');
                                        }
                                    } else {
                                        console.log("unexpected case, the bill is not found on both the target table's bill collection or current bill");
                                    }
                                } else {
                                    console.log(new Date() + " SYNC: local bill " + bill.id + " doesn't exist anywhere - add to local db");
                                    var billModel = new BillModel(bill);
                                    bills.add(billModel);
                                    table.trigger("change");
                                }
                            }
                        }
                    });

                    // remove any duplicate bill on more than one tables.
                    _.each(response.bills, function (bill) {
                        // console.log("deduplicating server bill " + bill.id);
                        POS.getTables().each(function (t) {
                            if (t.id == bill.table.id) {
                                // continue to next.
                                return;
                            }
                            var bills = t.getBillCollection();
                            var currentBill = t.getCurrentBill();
                            var localBill = bills.get(bill.id);
                            if (localBill) {
                                console.log("removed duplicate bill on different table: " + t.id + ' vs ' + bill.table.id);
                                bills.remove(localBill);
                            } else if (currentBill && currentBill.id == bill.id) {
                                console.log("removed duplicate current bill on different table: " + t.id + ' vs ' + bill.table.id);
                                t.setCurrentBill()
                            }
                        });
                    });
                    POS.refreshTableStatus()
                } finally {
                    console.log(new Date() + " finished syncing bills");
                    deferred.resolve();
                }
            });

            jxhr.fail(function (response) {
                console.log("BillRecorder.fetchAndSyncBills() failed to syncing bill");
                try {
                    //401 happens when login has expired, so we need to relogin again
                    //因为这个地方的原因，会导致页面自动刷新
                    //好的方法是在checkOnline时，加上权限认证
                    //如果未通过，则可以认为是离线状态，或者是告诉用户需要重新登录
                    if (response.status == 0) {
                        //Raven.captureMessage("session error", {extra: {restaurantId: POS.getRestaurant().id}});
                        TooieStatusService.statusModel().set({'status': 'SessionOffline'});
                        // window.location.reload();
                    } else if (response.status == 401) {
                        //Raven.captureMessage("session reload error", {extra: {restaurantId: POS.getRestaurant().id}});
                        window.location.reload();
                    } else {
                        DbRecorder.setOffline(POS.getRestaurant());
                    }
                } finally {
                    deferred.reject();
                }
            });
            return deferred;
        };


        /**
         * Update the sync status to off.
         */
        BillRecorder.setSyncStatusOff = function () {
            syncStatus.set({syncing: false});
            return $.Deferred().resolve();
        };

        /**
         * Update the sync status to off.
         */
        BillRecorder.setSyncStatusOn = function () {
            syncStatus.set({syncing: true});
            return $.Deferred().resolve();
        };

        /**
         * 从后台取bill的新状态，并与本地状态同步
         */
        BillRecorder.pollSyncHandle = null;
        BillRecorder.pollSync = function () {
            if (syncStatus.get('syncing')) {
                // if is syncing, then re-schedule immediately after syncing status is changed.
                console.log(new Date() + " syncing in progress - delay sync request till next cycle");
                syncStatus.once('change:syncing', function () {
                    self.reschedulePollSyncNow();
                });
                return;
            }
            console.log(new Date() + " syncing with server...");
            return self.setSyncStatusOn()
                // post 未完成的订单
                .then(self.postUnfinishedBills)
                .then(self.fetchAndSyncBills)
                .then(self.setSyncStatusOff)
                .then(self.reschedulePollSync)
                .fail(function () {
                    return self.setSyncStatusOff()
                        .then(self.reschedulePollSync);
                });
        };


        /**
         * Setup websockets
         * @param websocketAddress
         * @param pushChannelName
         */
        BillRecorder.setupWebSockets = function (pushChannelName) {
            function reconnect() {
                console.log(new Date() + " connecting to websocket at /stomp");
                var socket = new SockJS("/stomp");
                var client = Stomp.over(socket);
                client.debug = () => {};
                client.connect({}, function () {
                    DbRecorder.setWebSocketOnline();
                    PrintService.getPrinterStatus().set({offline: false});
                    client.subscribe("/topic/" + pushChannelName + "/tooie", function (message) {
                        // console.log(message.body);
                        var messageBody = message.body;
                        if (messageBody) {
                            var json = JSON.parse(messageBody);
                            if (json.event == 'TableBillChangeEvent') {
                                console.log(new Date() + " received bill " + json.payload.billId + " on table " + json.payload.tableId + " change event", json);
                                _.delay(self.reschedulePollSyncNow, 500);
                            } else if (json.event == "PrintErrorEvent") {
                                PrintService.logCloudPrintError(json.payload);
                            } else if (json.event == "PrinterStatusEvent") {
                                PrintService.logCloudPrinterStatus(json.payload);
                            } else if (json.event == "PrinterQueueEvent") {
                                PrintService.logCloudPrinterQueueEvent(json);
                            } else if (json.event == "PurchaseLicenseEvent") {
                                PurchaseLicenseService.chargeSuccess(json.payload);
                            } else if (json.event == "PushNotificationEvent") {
                                console.log(new Date() + " pay bill " + json.payload.notification.id);
                                NotificationService.saveNotification(json.payload.notification)
                            } else if (json.event == "BillPaidEvent") {
                                console.log(new Date() + " pay bill " + json.payload.billId + " use PayMode " + pushChannelName + " transNo =" + json.payload.transNo, json);
                                BillPayService.paidSuccess(message.payload);
                            } else if (json.event == "BillRefundEvent") {
                                console.log(new Date() + " refund bill " + json.payload.billId + " use PayMode " + pushChannelName, json);
                                BillPayService.refundPaid(json.payload);
                            }
                        }
                    })
                }, function (err) {
                    console.log('socket error', err);
                    DbRecorder.setWebSocketOffline(POS.getRestaurant());
                    setTimeout(() => {
                        console.log("reconnecting websocket after 5 seconds");
                        reconnect();
                    }, 5000);
                });
            }
            reconnect();
        };

        /**
         * Cancel any pending poll sync schedule.
         */
        BillRecorder.cancelPollSync = function () {
            if (self.pollSyncHandle) {
                clearTimeout(self.pollSyncHandle);
                self.pollSyncHandle = null;
            }
        };

        /**
         * Cancel existing then schedule a new poll sync schedule.
         */
        BillRecorder.reschedulePollSync = function (timeoutOverride) {
            self.cancelPollSync();
            console.log(new Date() + " scheduling next poll sync in " + (timeoutOverride || retrieveNewBillsInterval) + 'ms');
            self.pollSyncHandle = setTimeout(self.pollSync, timeoutOverride || retrieveNewBillsInterval);
        };

        /**
         * Reschedule poll sync now but throttled to be called again only within 500ms.
         */
        BillRecorder.reschedulePollSyncNow = _.debounce(function () {
            self.reschedulePollSync(1);
        }, 200);


        /**
         * Initialise the whole BillRecorder mechanism.
         * @param websocketAddress
         * @param pushChannelName
         */
        BillRecorder.initialize = function (pushChannelName) {
            self.setupWebSockets(pushChannelName);
            self.monitorTables();
            DbRecorder.getStatusModel().on('change', () => {
                if (DbRecorder.getStatusModel().get('online')) {
                    BillRecorder.reschedulePollSyncNow();
                }
            });
            return self.pollSync().then(self.printBills);
        };

        //BillRecorder.reschedulePollSyncNow = reschedulePollSyncNow;

        return BillRecorder;
    })();
};

let exportedValue = main();

export default exportedValue;



// WEBPACK FOOTER //
// ./src/recorder/BillRecorder.js